import http from '../helpers/http';

const Loa = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    loaPolicyShow: async (schoolId: string, id: string) => {
      const result = await http.get(`/loa-policies/${schoolId}/${id}`, {
        headers,
      });
      return result.data;
    },
    loaPolicyCreate: async (schoolId: string, body: any) => {
      const result = await http.post(`/loa-policies/${schoolId}`, body, { headers });
      return result.data;
    },
    loaPolicyUpdate: async (schoolId: string, id: string, body: any) => {
      const result = await http.put(`/loa-policies/${schoolId}/${id}`, body, { headers });
      return result.data;
    },
    loaPolicyList: async (schoolId: string) => {
      const result = await http.get(`/loa-policies/${schoolId}`, {
        headers,
      });
      return result.data;
    },
    delete: async (schoolId: string, id: string) => {
      const result = await http.delete(`/loa-policies/${schoolId}/${id}`, {
        headers,
      });
      return result.data;
    },
  };
};

export default Loa;
